export default __webpack_public_path__ + "static/media/PNG.0fce9e47.png";